import React from 'react';
import PropTypes from 'prop-types';
import MyAppCard from './MyAppCard';
import DiscoverViewAllButton from './DiscoverViewAllButton';
import RecommendedTools from './RecommendedTools';

const RECOMMENDED = 'recommended';

const DiscoverCategory = props => {
  const {
    title,
    items,
    subcategoryIndex,
    showViewAll,
    tools,
    toggleFavorite,
    setApp,
    setTool,
    user,
    changeTab
  } = props;

  const appCardItems = items.filter(item => item !== RECOMMENDED),
    recommendedCardItems = items.filter(item => item === RECOMMENDED);

  return (
    <div className="discover-category">
      <h2 className="tools-category-heading tools-category-heading-discover">
        {title}
        {showViewAll && (
          <DiscoverViewAllButton
            subcategoryIndex={subcategoryIndex}
            changeTab={changeTab}
          />
        )}
      </h2>
      <div className={`tools-discover-category`}>
        {recommendedCardItems.length > 0 && <RecommendedTools {...props} />}
        {appCardItems.map((item, index) => (
          <MyAppCard
            app={item}
            user={user}
            key={index}
            tools={tools}
            setApp={setApp}
            setTool={setTool}
            toggleFavorite={toggleFavorite}
          />
        ))}
      </div>
    </div>
  );
};

DiscoverCategory.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  subcategoryIndex: PropTypes.string,
  showViewAll: PropTypes.bool,
  user: PropTypes.object,
  toggleFavorite: PropTypes.func,
  setApp: PropTypes.func,
  setTool: PropTypes.func,
  tools: PropTypes.object,
  recommendations: PropTypes.array,
  changeTab: PropTypes.func
};

export default DiscoverCategory;
